import React from 'react';
import {Progress, Button, Modal, ModalHeader, ModalFooter, ModalBody,Dropdown,DropdownMenu , Alert, DropdownToggle,DropdownItem,Form,FormGroup, FormText,Label, Input  } from 'reactstrap';
import $ from 'jquery';
import { connect } from 'react-redux'
import { setUser, loginUser, OauthLogin } from '../../reducers/actions';
import { logoutUser } from '../../reducers/actions';

class NotAuthorisedModal extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            user: '',
            password: '',
            modal: true,
            ...props
        }

        this.toggle = this.toggle.bind(this)
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        })
    }

    onFailure = (error) => {
        console.error(error);
    };

    logoutUser = () => {
        this.props.dispatch(logoutUser());
    }


    render() {
        return (
         <div className="childDiv">
            <Modal isOpen={this.props.modal} toggle={this.toggle} backdropClassName='modal-custom-backdrop'>
                <ModalHeader>Not Authorised</ModalHeader>
                    <ModalBody>
                        <ModalBody>
                            You don't have the relevant permissions to view this page, sorry.
                        </ModalBody>
                    </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => this.logoutUser()} >
                        Logout
                    </Button>
                </ModalFooter>
            </Modal>
         </div>
        )
    }
}

export default connect(state => state)(NotAuthorisedModal); 